export function buildSegmentPageEvent(args) {
  return {
    name: undefined,
    category: undefined,
    properties: {
      ...buildActionTrackerPage(args),
      path: location?.pathname,
      title: document?.title,
      referrer: document?.referrer,
      search: location?.search,
      application: args.category,
      pageRequestId: args.request_id || 'undefined',
    },
  };
}

// Create the page params based on the values passed into args
export function buildActionTrackerPage(args) {
  let params = {
    url: location.href.split('#')[0],
    visitorId: args.visitor_id,
    divisionId: args.division_id || 'VT::VT',
    userAgent: navigator.userAgent,
    contentVersion: args.content_version || getMeta('content-version'),
    nspSlug: getMetaProperty('nsp-slug') || '',
    nspSlugType: getMetaProperty('nsp-slug-type') || '',
    cache: (args.cache || 'none').toLocaleLowerCase(),
    applicationTime: args.applicationTime,
    firstContentfulPaintTime: args.firstContentfulPaintTime,
  };

  // Set optional params if they are present
  const optionals = {
    clientUuid: 'client_uuid',
    entity: 'entity',
    sessionId: 'session_id',
    userId: 'user_id',
  };
  Object.keys(optionals).forEach((key) => {
    if (args[optionals[key]]) {
      params[key] = args[optionals[key]];
    }
  });

  if (args.ab_test_experiment && args.ab_test_variant) {
    params.tests = [
      {
        experimentId: args.ab_test_experiment,
        variantId: args.ab_test_variant,
      },
    ];
  }

  return params;
}

/**
 * Gets the content of a meta tag from the page
 * @param {String} name - Name of meta tag
 * @return {String|null} The content of the meta tag
 */
function getMeta(name) {
  const meta = document.querySelector(`meta[name=${name}]`);
  return meta ? meta.content : null;
}

/**
 * Gets the content of a meta tag from the page
 * @param {String} property - Property value of meta tag
 * @return {String|null} The content of the meta tag
 */
function getMetaProperty(property) {
  const meta = document.querySelector(`meta[property=${property}]`);
  return meta ? meta.content : null;
}
